<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择上级区域"
      width="900px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="districts"
        @select="selectCustomer"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" @submit.native.prevent>
          <el-form-item label="区域名称" prop="filter">
            <el-input v-model.trim="filter.districtName" placeholder="请输入区域名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          districtName: "",
        },
        columns: [
          {
            title: "区域编号",
            key: "districtNO",
            width: 140,
          },
          {
            title: "区域名称",
            key: "districtName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectCustomer(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
